import { LaasCalenderComponent } from './../../../setting/pages/laas-calender/laas-calender.component';
import { DoMergeComponent } from './../../components/do-merge/do-merge.component';
import { CommonDataService } from './../../../../core/services/common-data.service';
import { MergeKeySearechResult } from '../../../../core/models/transport-operation/merge-key-searech-result';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { ChangeDetectorRef, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { getDataScopeByPermission, isNullOrEmpty, laaSFormatString ,getCreateDateBy} from 'src/app/core/utils/common-functions';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { DateTableColumn } from 'src/app/core/models/date-table-column';
import { PageInfo } from 'src/app/core/models/page-info';
import { LaasOption } from 'src/app/core/models/laas-option';
import { CodeConverterOptions } from 'src/app/core/models/options/code-converter-options';
import { MergeKeyService } from '../../services/merge-key.service';
import { QueryMergeKeyRequest } from 'src/app/core/models/transport-operation/query-merge-key-request';
import { copyFormControl } from 'src/app/core/utils/validation-functions';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { RowExpandedEvent } from 'src/app/core/models/event/row-expanded-event';
import { MergeKeyDetailResult } from 'src/app/core/models/transport-operation/merge-key-detail-result';
import { HttpErrorResponse } from '@angular/common/http';
import { DoMerge } from 'src/app/core/enums/do-merge.enum';
import { DoMergeSearchResult } from 'src/app/core/models/transport-operation/do-merge-search-result';
import { MergedDeliveryOrderRequest } from 'src/app/core/models/transport-operation/merged-delivery-order-request';
import { MergeKeyDetailAdditionRequest } from 'src/app/core/models/transport-operation/merge-key-detail-addition-request';
import { MergeKeyDeleteRequest } from 'src/app/core/models/transport-operation/merge-key-delete-request';
import { FacilityService } from 'src/app/core/services/facility.service';
import { AddressMaintainanceService } from 'src/app/features/setting/service/address-maintainance.service';
import { LetterHeadOrgOptions } from 'src/app/core/models/options/letter-head-org-options';
import { MergeKeyCreationRequest } from 'src/app/core/models/transport-operation/merge-key-creation-request';
import { MergeKeyConfirmationCancelRequest } from 'src/app/core/models/transport-operation/merge-key-confirmation-cancel-request';
import { MergeKeyConfirmationRequest } from 'src/app/core/models/transport-operation/merge-key-confirmation-request';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { InstantBookingRequest } from 'src/app/core/models/transport-operation/instant-booking-request';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { ConfirmationDiff } from 'src/app/core/models/transport-operation/confirmation-diff';
import { ConfirmationError } from 'src/app/core/models/transport-operation/confirmation-error';
import { NotificationSubScriptionService } from 'src/app/core/services/notification-sub-scription.service';
import { ActivatedRoute, Params } from '@angular/router';
import { CodeConverter } from 'server/entity/code-converter';
import { ForwarderService } from '../../services/forwarder.service';
import { Checkbox } from 'primeng/checkbox';
import { ChangeMergeKeyMixFacilityRequest} from 'src/app/core/models/transport-operation/change-merge-key-mixfaility-request';
import { CancelDeliveryOrderMergeRequest } from 'src/app/core/models/transport-operation/cancel-delivery-order-merge-request';
import { CancelMergeKeyRequest } from 'src/app/core/models/transport-operation/cancel-merge-key-request';
import { OrderQueryScopeEnum } from 'src/app/core/enums/order-query-scope.enum';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { MenuItem } from 'primeng/api';
import { Menubar } from 'primeng/menubar';


@Component({
  selector: 'laas-merge-key-search',
  templateUrl: './merge-key-search.component.html',
  styleUrls: ['./merge-key-search.component.scss']
})
export class MergeKeySearchComponent extends SessionBaseComponent implements OnInit {

  readonly permissionCode = PermissionConstants.ViewMergeKeySearch;
  readonly preferenceKey: string = UserPreferenceConstants.MergeKeySearch;
  readonly preferenceKey2: string = UserPreferenceConstants.MergeKeySearchDetail;
  readonly preferenceKey3: string = UserPreferenceConstants.MergeDoPreview;
  protected readonly OrderQueryScopeEnum = OrderQueryScopeEnum;
  currentLang: string = this.laasSetting.language;

  @ViewChild('createDt') createDt! : LaasCalenderComponent;
  isSearchFormOpen: boolean = true;
  searchForm!: FormGroup;
  selectedRows: MergeKeySearechResult[] = [];
  isMixFacilityStatusNotSame: boolean = false;
  hasSelectedCancelledMergeKey: boolean = false;
  selectedDoTaskRows: MergeKeyDetailResult[] = [];
  isLoading: boolean = false;
  results: MergeKeySearechResult[] = [];
  dataTableColumns: DateTableColumn[] = [];
  pageInfo: PageInfo;
  sortOrder?: { property: string; direction: number };
  confirmStatusOptions: LaasOption[] = [];
  isWithdrawBtnVisible = false;
  isShowMergeDialog: boolean = false;
  searchParams: QueryMergeKeyRequest = new QueryMergeKeyRequest();
  @ViewChild(DataTableComponent) table!: DataTableComponent;
  mergeKey: string | null = null;
  detailColumns: DateTableColumn[] = [];
  doStatusOptions: LaasOption[] = [];
  doMergeType: DoMerge = DoMerge.Merge;
  @ViewChild(DoMergeComponent) laasDoMerge!: DoMergeComponent;
  currentImportMergeKey: MergeKeySearechResult | null = null;
  isShowMergePreviewDialog: boolean = false;
  dataTableDoMergePreviewColumns: DateTableColumn[] = [];
  letterHeadOrgIdOptions: LaasOption[] = [];
  consigneeKeyOptions: LaasOption[] = [];
  consigneeKeyOptionsMapping: LaasOption[] = [];
  mergePreviewDos: DoMergeSearchResult[] = [];
  MergeTaskCodeOptions: LaasOption[] = [];

  consigneeSearchParams:any;
  queryFlag: boolean = true;

  mergeStatusOptions: LaasOption[] = [];
  bookingTypeOptions: LaasOption[] = [];
  mergeTaskCodeOptions: LaasOption[] = [];
  forwarderOptions: Array<LaasOption> = [];
  hkFacilityOptions: any[];
  isMixFacility: boolean = false;
  @ViewChild('mixFacility') mixFacilityCheckBox!: Checkbox;
  disPlayIsMixFacilityCheckBox: boolean = false;


  isMixFacilityOption: LaasOption[] = [];
  isSmallScreen = false;
  readonly SMALL_SCREEN = 1770;
  checkMixFacilityDialog: boolean = false;
  checkMixFacilityDialogKey: any;
  moreActionsMenuItems: MenuItem[] = [];
  @ViewChild('moreActionsMenubar') moreActionsMenubar!: Menubar;

  constructor(
    injector: Injector,
    private fb: FormBuilder,
    private commonDataService: CommonDataService,
    private mergeKeyService: MergeKeyService,
    private facilityService: FacilityService,
    private addressMaintainanceService: AddressMaintainanceService,
    private notificationSubScriptionService:NotificationSubScriptionService,
    private changeDetector: ChangeDetectorRef,
    private route: ActivatedRoute,
    private forwarderService: ForwarderService
  ) {
    super(injector);

    this.pageInfo = { pageSize: 5, pageIndex: 0, totalRecords: 0, totalPages: 0 };
    const dataTablePreference = this.getDataTablePreference(this.preferenceKey);
    this.sortOrder = isNullOrEmpty(dataTablePreference?.state?.sortField) || isNullOrEmpty(dataTablePreference?.state?.sortOrder) ? undefined :
      { property: dataTablePreference?.state?.sortField as string, direction: dataTablePreference?.state?.sortOrder as number };

    this.dataTableColumns = [
      { field: 'mergeKey', header: 'MergeKey.MainTable.MergeKey', sort: true },
      { field: 'isConfirm', header: 'MergeKey.MainTable.ConfirmStatus', sort: true },
      { field: 'bookingNo', header: 'MergeKey.MainTable.BookingNo', sort: true },
      { field: 'createUser', header: 'MergeKey.MainTable.CreateUser', sort: true },
      { field: 'createDt', header: 'MergeKey.MainTable.CreateDt', sort: true },
      { field: 'bookingType', header: 'MergeKey.MainTable.BookingType', sort: true },
      { field: 'isMixFacility', header: 'MergeKey.MainTable.IsMixFacility', sort: true },
      { field: 'confirmUser', header: 'MergeKey.MainTable.ConfirmUser', sort: true },
      { field: 'confirmDt', header: 'MergeKey.MainTable.ConfirmDt', sort: true },
      { field: 'doQty', header: 'MergeKey.MainTable.DOQty', sort: true }
    ];

    this.detailColumns = [
      { field: '__delete', header: 'MergeKey.DetailTable.Delete', sort: false },
      { field: 'doNo', header: 'MergeKey.DetailTable.DoNo', sort: true },
      { field: 'facility', header: 'MergeKey.DetailTable.Facility', sort: true },
      { field: 'consigneeKey', header: 'MergeKey.DetailTable.ConsigneeKey', sort: true },
      { field: 'consigneeCompany', header: 'MergeKey.DetailTable.ConsigneeCompany', sort: true },
      { field: 'cartonCnt', header: 'MergeKey.DetailTable.CartonCnt', sort: true },
      { field: 'doStatus', header: 'MergeKey.DetailTable.DoStatus', sort: true },
      { field: 'mergeStatus', header: 'MergeKey.DetailTable.MergeStatus', sort: true },
      { field: 'taskCode', header: 'DoMerge.MainTable.TaskCode', sort: true },
    ];

    this.dataTableDoMergePreviewColumns = [
      { field: '__delete', header: 'MergeKey.DetailTable.Delete', sort: false },
      { field: 'doNo', header: 'DoMerge.MainTable.DoNo', sort: true },
      { field: 'letterHeadOrgId', header: 'DoMerge.MainTable.LetterHeadOrgId', sort: true },
      { field: 'consigneeKey', header: 'DoMerge.MainTable.ConsigneeKey', sort: true },
      { field: 'doStatus', header: 'DoMerge.MainTable.DoStatus', sort: true },
      { field: 'facility', header: 'DoMerge.MainTable.Facility', sort: true },
      { field: 'invoiceNo', header: 'DoMerge.MainTable.InvoiceNo', sort: true },
      { field: 'etd', header: 'DoMerge.MainTable.ETD', sort: true, dataType: "date"},
      { field: 'isDropRemark', header: 'DoMerge.MainTable.IsDropRemark', sort: true },
      { field: 'deliveryTo', header: 'DoMerge.MainTable.DeliveryTo', sort: true },
      { field: 'shipTo', header: 'DoMerge.MainTable.ShipTo', sort: true },
      { field: 'taskCode', header: 'DoMerge.MainTable.TaskCode', sort: true },
      { field: 'taskValue', header: 'DoMerge.MainTable.TaskValue', sort: true },
      { field: 'assignForwarder', header: 'DoMerge.MainTable.AssignForwarder', sort: true },
    ];

    this.hkFacilityOptions = [];


    this.searchForm = this.fb.group({
      mergeKeys: [],
      doNos: [],
      consigneeKeys: [],
      createUser: null,
      createDtStart: null,
      createDtEnd: null,
      confirmStatus: null,
      orderQueryScope: [this.OrderQueryScopeEnum.all, Validators.required]
    });

    this.consigneeSearchParams = {
      consigneeKey: null,
      consigneeCompany: null
    };

    this.checkMixFacilityDialogKey = null;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.isMixFacilityOption = [
      { label: 'N', value: "N" },
      { label: 'Y', value: "Y" },
    ];

    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    // 撤回
    if (this.userProfile.userType === UserType.SuperAdmin.toString() ||
        this.permissionCodes.includes(PermissionConstants.BtnMergeKeyCSRWithdraw)) {
      this.isWithdrawBtnVisible = true;
    }

    this.buildMoreActionsMenu();
    this.translateService.onLangChange.subscribe(() => this.buildMoreActionsMenu());

    this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "MergeKeyConfirmStatus").subscribe({
      next: (options: CodeConverterOptions[]) => {
        this.confirmStatusOptions = options.map(x => ({ label: `${x.codeKey} - ${x.codeDesc}`, value: x.codeKey }));
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "DoStatus").subscribe({
      next: (options: CodeConverterOptions[]) => {
        this.doStatusOptions = options.map(x => ({ label: `${x.codeKey} - ${x.codeDesc}`, value: x.codeKey }));
      }
    });

    this.facilityService.getLetterOrgOptions(this.laasSetting.facility, "").subscribe({
      next: (options: LetterHeadOrgOptions[]) => {
        this.letterHeadOrgIdOptions = options.map(x => ({label:`${x.legalEntityOUCode} - ${x.legalEntityOUName}`, value:x.legalEntityOUCode}))
      }
    });

    this.commonDataService.getAppCsmSetting('HKFacilitySetting').subscribe({
      next:(option:any)=>{
        this.hkFacilityOptions = option.appCsmSettingDetailList;
        console.log("this.hkFacilityOptions" + this.hkFacilityOptions);
      }
    });

    this.addressMaintainanceService.getCustomerOptions().subscribe({
      next: (result) => {
        this.consigneeKeyOptionsMapping = [...result].map((x: any) => {
          return {
            label: `${x.customerCode} - ${x.customerName}`,
            value: x.customerCode,
          };
        });
      },
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "MergeStatus").subscribe({
      next: (options: CodeConverterOptions[]) => {
        this.mergeStatusOptions = options.map(x => ({ label: `${x.codeKey} - ${x.codeDesc}`, value: x.codeKey }));
        console.log(this.mergeStatusOptions);
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "BookingType").subscribe({
      next: (options: CodeConverterOptions[]) => {
        this.bookingTypeOptions = options.map(x => ({ label: `${x.codeKey} - ${x.codeDesc}`, value: x.codeKey }));
      }
    });

    // get param to auto query
    this.route.queryParams.subscribe((params: Params) => {
      params = Object.values(params);
      if (params.length != 0) {
        const mergekeyNos = params[0].split(";");
        this.searchForm.controls["mergeKeys"].setValue(mergekeyNos);
        this.searchClickBtn(new Event('click'));
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "MergeTaskCode").subscribe({
      next: (options: CodeConverter[]) => {
        this.mergeTaskCodeOptions = options.map(x => ({ label: `${x.codeKey ?? ""} - ${x.codeDesc ?? ""}`, value: x.codeKey ?? "" }))
      }
    });

    this.forwarderService.getForwarderOptions().subscribe({
      next: (options: any[]) => {
        this.forwarderOptions = options.map((x) => ({
          label: `${x.text}`.replace(' ', ' - '),
          value: x.value,
        }));

        this.translateService.get('Common.Message.ChooseOption').subscribe({
          next: (msg) => {
            this.forwarderOptions.unshift({
              label: msg,
              value: '',
            });
          },
        });
      },
    });
  }

  async setPageSize(event: any): Promise<void>{
    this.pageInfo.pageSize = event.rows;
  }

  tablePageChange(event: any): void {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.getMergeKeyResult();
  }

  tableSort(event: any): void {
    this.sortOrder = { property: event.field, direction: event.order };
    this.pageInfo.pageIndex = 0;
    this.table.setCurrentPage(0);
    this.getMergeKeyResult();
  }

  searchClickBtn(event: Event): void{
    this.isSearchFormOpen = false;
    this.pageInfo.pageIndex = 0;
    this.table.setCurrentPage(0);
    this.getMergeKeyResult();
  }

  resetClickBtn(event: Event): void{
    this.searchForm.reset({
      orderQueryScope: this.OrderQueryScopeEnum.all
    });
    this.createDt.ngOnInit();
  }

  searchDetailClick(event: RowExpandedEvent<MergeKeySearechResult>): void{
    const rowData = event.rowData;
    const isClosed = event.expanded;

    this.selectedDoTaskRows = [];

    if (isClosed) {
      return;
    }

    this.isLoading = true;

    this.mergeKey = rowData.mergeKey;
    this.mergeKeyService.getMergeKeyDetail(this.mergeKey ?? "")
      .subscribe({
        next: result => {
          rowData.details = [...result];
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        }
      });
  }

  getMergeKeyResult(): void{
    this.loader.show();
    this.setSelectedRows([]);

    // permission information
    var dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);
    this.searchParams.dataScopes = dataScopes;
    this.searchParams.userEmail = this.userService.userInfo.email;

    // Page information
    this.searchParams.pageIndex = this.pageInfo.pageIndex;
    this.searchParams.pageSize = this.pageInfo.pageSize;
    const propertyIsNullOrEmpty = isNullOrEmpty(this.sortOrder) || isNullOrEmpty(this.sortOrder?.property);
    const directionIsNullOrEmpty = isNullOrEmpty(this.sortOrder) || isNullOrEmpty(this.sortOrder?.direction);
    const sortOrder: SortOrder = {
      property: propertyIsNullOrEmpty ? 'MergeKey' : this.sortOrder?.property,
      direction: directionIsNullOrEmpty ? -1 : this.sortOrder?.direction
    };
    this.searchParams.sortOrder = sortOrder;

    // Search parameters
    this.searchParams.mergeKeys = this.searchForm.value.mergeKeys;
    this.searchParams.doNos = this.searchForm.value.doNos;
    this.searchParams.consigneeKeys = this.searchForm.value.consigneeKeys;
    this.searchParams.createUser = isNullOrEmpty(this.searchParams.createUser) ? null : this.searchParams.createUser;
    this.searchParams.createDtStart = isNullOrEmpty(this.searchForm.value.createDtStart) ? null : this.searchForm.value.createDtStart;
    this.searchParams.createDtEnd =  isNullOrEmpty(this.searchForm.value.createDtEnd) ? null : this.searchForm.value.createDtEnd;
    this.searchParams.timeZone = this.laasSetting.facilityTimeZone;
    this.searchParams.confirmStatus = this.searchForm.value.confirmStatus;
    this.searchParams.orderQueryScope = this.searchForm.value.orderQueryScope;

    console.log('Search form:', this.searchForm.value);
    console.log('Search params:',this.searchParams);

    this.mergeKeyService.queryMergeKey(this.searchParams).subscribe({
      next: pageResults => {
        this.results = pageResults.content;
        console.log(this.results);
        this.pageInfo.totalRecords = pageResults.totalElements;
        this.pageInfo.totalPages = pageResults.totalPages;
      },
      complete: () => {
        this.loader.hide();
      }
    })
  }

  openMergeDialog(event: Event): void{
    this.doMergeType = DoMerge.Merge;
    this.isShowMergeDialog = true;
  }

  openImportDialog(event: Event, rowData: MergeKeySearechResult): void{
    this.currentImportMergeKey= rowData;
    this.doMergeType = DoMerge.Import;
    this.isShowMergeDialog = true;
  }

  showDialog(event: Event): void{
    this.laasDoMerge.resetComponent(event);
  }

  chipsAdd(event: any, fromControlName: any): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').map(x => x.trim()).filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    const formControl = this.searchForm.get(fromControlName);
    formControl?.value.splice(formControl?.value.indexOf(value));
    formControl?.setValue(formControl?.value.concat(parsedValues));
  }

  formatTableTitle(mergeKey: MergeKeySearechResult): string {
    return `Merge Key Detail - ${mergeKey.mergeKey}`;
  }

  async deleteBtnClick(event: Event, rowData: MergeKeyDetailResult): Promise<void> {

    var confirmMessage = await this.translateService.get('MergeKey.Confirm.DeleteConfirmMessage').toPromise();
    var confirmMessageWithMixFacility = await this.translateService.get('MergeKey.Confirm.CheckMixFacility').toPromise();

        this.confirmationService.confirm({
          message: `${rowData.doNo} - ${confirmMessage}`,
          rejectVisible: true,
          accept: () => {

            this.loader.show();

            this.mergeKeyService.deleteMergeKeyDetail(rowData.mergeKey, rowData.doNo).subscribe({
              next: result => {
                this.confirmationService.close();
                if (result.mixFacility) {
                  this.checkMixFacilityDialog = true;
                  this.checkMixFacilityDialogKey = rowData.mergeKey;
                }

                var currentMother = this.results.filter((x: MergeKeySearechResult) => {
                  return x.mergeKey == rowData.mergeKey;
                });
                if(currentMother.length > 0){
                  this.searchDetailClick({
                    originEvent: event,
                    rowData: currentMother[0],
                    expanded: false
                  } as RowExpandedEvent<MergeKeySearechResult>);
                }
              },
              error: err => {
                this.toastErrorMessage(err.error);
                this.loader.hide();
              },
              complete: () =>{
                this.loader.hide();
              }
            });
          },
          reject: () => {
            this.confirmationService.close();
          }
        });
  }

  removeMergeKeyBtn(event: Event): void{
    this.loader.show();

    var req: MergeKeyDeleteRequest = {
      mergeKeys: this.selectedRows.filter((x: MergeKeySearechResult) => {
        return !isNullOrEmpty(x.mergeKey);
      }).map(x => x.mergeKey as string)
    }

    this.mergeKeyService.mergeKeyDelete(req).subscribe({
      next: result =>{
        this.searchClickBtn(event);
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.loader.hide();
      },
      complete: () => {
        this.loader.hide();
      }
    })
  }

  importDoEvent(selectDos: DoMergeSearchResult[]): void {
    this.mergePreviewDos = [...selectDos];
    this.isShowMergeDialog = false;
    this.isShowMergePreviewDialog = true;
    this.disPlayIsMixFacilityCheckBox = false;
  }

  mergeDoEvent(selectDos: DoMergeSearchResult[]): void {
    this.mergePreviewDos = [...selectDos];
    this.isShowMergeDialog = false;
    this.isShowMergePreviewDialog = true;
    this.checkMixFacility();
  }

  doPreviewDeleteBtn(event: Event, rowData: DoMergeSearchResult): void {
    this.mergePreviewDos = [...this.mergePreviewDos].filter(x => {
      return !(x.doNo === rowData.doNo);
    });
    this.checkMixFacility();
  }
  
  checkMixFacility(): void {
    this.isMixFacility = false;

    const uniqueFacility = new Set(this.mergePreviewDos.map(object => object.facility));
    if (uniqueFacility.size >= 2) {
      this.disPlayIsMixFacilityCheckBox = true;
      this.isMixFacility = true;
      setTimeout(() => {
        this.mixFacilityCheckBox.value = this.isMixFacility;
      });
    }
  }

  mergeDos(event: Event): void {

    this.loader.show();

    var req: MergeKeyCreationRequest = {
      doNos: this.mergePreviewDos.map(x => x.doNo as string),
      userId: this.userProfile.email,
      mixFacility : this.isMixFacility
    };

    this.mergeKeyService.mergeKeyCreation(req).subscribe({
      next: result => {
        this.mergePreviewDos = [];
        this.isShowMergePreviewDialog = false;

        this.searchForm.controls["mergeKeys"].setValue([result.mergeKey]);
        this.searchClickBtn(event);
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.loader.hide();
      },
      complete: () => {
        this.loader.hide();
      }
    });
  }

  confirmWithdrawBtn(event: Event): void {
    this.loader.show();

    var req: MergeKeyConfirmationCancelRequest = {
      mergeKeys: this.selectedRows.filter((x: MergeKeySearechResult) => {
        return !isNullOrEmpty(x.mergeKey);
      }).map(x => x.mergeKey as string),
      userId: this.userProfile.loginAccount
    };

    this.mergeKeyService.mergeKeyConfirmationWithdraw(req).subscribe({
      next: async (result) => {
        this.searchClickBtn(event);
        this.setSelectedRows([]);

        var msg = await this.translateService.get("MergeKey.Info.Success").toPromise();
        this.toastService.success(msg);
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.loader.hide();
      },
      complete: () => {
        this.loader.hide();
      }
    })
  }

  confirmBtn(event: Event): void{
    this.loader.show();

    var req: MergeKeyConfirmationRequest = {
      mergeKeys: this.selectedRows.filter((x: MergeKeySearechResult) => {
        return !isNullOrEmpty(x.mergeKey);
      }).map(x => x.mergeKey as string),
      userId: this.userProfile.loginAccount
    };

    this.mergeKeyService.mergeKeyConfirmation(req).subscribe({
      next: async (result) => {
        this.searchClickBtn(event);
        this.setSelectedRows([]);

        if(result?.failedConfirmationDiff?.length > 0 || result?.failedConfirmationError?.length > 0){
          var msg = await this.translateService.get("MergeKey.Info.MergeRuleMsg").toPromise();
          msg += "\n";
          result?.failedConfirmationDiff?.forEach((x: ConfirmationDiff, index: number) => {
            msg += `${x.mergeKey}: ${x.diffColumns?.join(", ")} are different\n`;
          });

          result?.failedConfirmationError?.forEach((x: ConfirmationError, index: number) => {
            msg += `${x.mergeKey}: ${x.errorMsg}\n`;
          });

          this.toastService.warn(msg, true);
        }else{
          var msg = await this.translateService.get("MergeKey.Info.Success").toPromise();
          this.toastService.success(msg);
        }

        if(result?.instantBooking?.length > 0){
          var instantMsg = await this.translateService.get("MergeKey.Confirm.InstantBooking").toPromise();
          var confirmMsg = await this.translateService.get("MergeKey.Confirm.InstantBookingConfirm").toPromise();

          let msg = "";

          result?.instantBooking?.forEach(x => {
            msg += `${laaSFormatString(instantMsg, [x.mergeKey, x.carTrip])}\n`;
          });

          msg += `${confirmMsg}`;

          this.confirmationService.confirm({
            message: msg,
            accept: () => {
              let mergeKeys = result?.instantBooking?.map(x => x.mergeKey);
              this.instantBooking(mergeKeys);
            },
            reject: () => {
              this.confirmationService.close();
            }
          });

        }
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.loader.hide();
      },
      complete:  () => {
        this.loader.hide();
      }
    })
  }

  instantBooking(mergeKeys: string[]): void {
    this.loader.show();

    let req: InstantBookingRequest = {
      facility: this.laasSetting.facility,
      mergeKeys: mergeKeys,
      userId: this.userProfile.loginAccount
    };

    this.mergeKeyService.instantBooking(req).subscribe({
      next: (result) => {
        let bookingSuccess = this.translateService.instant("MergeKey.Info.BookingCreateSuccess");
        let failedMergeKey = this.translateService.instant("MergeKey.Info.MergeKeyFailed");
        let bookings: string[] = [];
        for (const instantBookingSuccessResponse of result?.successfulBooking) {
          console.log(instantBookingSuccessResponse);
          if (instantBookingSuccessResponse.extraWorkMergeFlag == 'N') {
            bookings.push(instantBookingSuccessResponse.bookingNo);
          }
        }

        let failedMergeKeys = result?.failedBooking;

        let msg = "";

        if(bookings?.length > 0){
          msg += `${bookingSuccess} ${bookings.join(", ")}`;
        }

        if(failedMergeKeys?.length > 0){
          msg += `\n ${failedMergeKey} ${failedMergeKeys.join(", ")}`;
        }

        if (bookings.length > 0) {
          this.toastService.success(msg, true);
        }
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.loader.hide();
      },
      complete: () => {
        this.loader.hide();
      }
    });
  }

  getCustomerOptions(event: any) {
    const conText: string = event.filter;
    if (conText != null && conText.length > 0 && this.queryFlag) {
      this.queryFlag = false;

      this.notificationSubScriptionService.getCustomerOptionsByFilter(conText).subscribe({
        next: (options: any[]) => {
          this.consigneeKeyOptions = options.map<LaasOption>(x => ({
            label: x.customerCode + ' - ' + x.customerName,
            value: x.customerCode,
          }));
          this.changeDetector.detectChanges();
          this.queryFlag = true;
        }
      });
    }
  }

  importDos(selectDos: DoMergeSearchResult[]): void {

    this.loader.show();

    var request = new MergeKeyDetailAdditionRequest();
    request.doNos = [...new Set(selectDos.filter(x => {
      return !isNullOrEmpty(x.doNo);
    }).map(x => {
      return x.doNo as string;
    }))];
    request.mergeKey = this.currentImportMergeKey?.mergeKey;
    request.facility = this.laasSetting.facility;
    request.userId = this.userProfile.loginAccount;
    request.mixFacility = this.isMixFacility;

    this.mergeKeyService.mergeKeyDetailAddition(request).subscribe({
      next: result => {
        // Update header's Infomation
        this.getMergeKeyResult();
        var currentMother = this.results.filter((x: MergeKeySearechResult) => {
          return x.mergeKey === this.currentImportMergeKey?.mergeKey;
        });

        if (currentMother.length > 0) {
          this.searchDetailClick({
            rowData: currentMother[0],
            expanded: false
          } as RowExpandedEvent<MergeKeySearechResult>);
        }
        this.isShowMergePreviewDialog = false;
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.loader.hide();
      },
      complete: () => {
        this.loader.hide();
      }
    });
  }

  displayActionBtn(type: string): boolean{
    return this.doMergeType?.toString() === type;
  }

  async onSelectedRowsChange(rows: MergeKeySearechResult[]): Promise<void> {
    const wasMixFacilityStatusNotSame = this.isMixFacilityStatusNotSame;
    this.setSelectedRows(rows);

    if (this.isMixFacilityStatusNotSame && !wasMixFacilityStatusNotSame) {
      var warnMsg = await this.translateService.get("MergeKey.Info.MixFacilityStatusNotSame").toPromise();
      this.toastService.warn(warnMsg, true);
    } else if (!this.isMixFacilityStatusNotSame && wasMixFacilityStatusNotSame) {
      this.toastService.clear();
    }
  }

  setSelectedRows(rows: MergeKeySearechResult[]): void {
    this.selectedRows = rows;

    const mixFacilityValues = rows.map((x: MergeKeySearechResult) => x.isMixFacility === 'Y');
    this.isMixFacilityStatusNotSame = mixFacilityValues.some(x => x !== mixFacilityValues[0]);

    this.hasSelectedCancelledMergeKey = rows.some((x: MergeKeySearechResult) => x.isConfirm === 'C');
  }

  async toggleMixFacilityBtn(event: Event) {
    const targetMixFacility = !(this.selectedRows[0]?.isMixFacility === 'Y');

    let req: ChangeMergeKeyMixFacilityRequest = {
      mergeKeys: this.selectedRows.filter((x: MergeKeySearechResult) => {
        return !isNullOrEmpty(x.mergeKey);
      }).map(x => x.mergeKey as string),
      userId: this.userProfile.loginAccount,
      mixFacility: targetMixFacility
    };
    this.mergeKeyService.changeMixFaility(req).subscribe({
      next: async (result) => {
        this.searchClickBtn(event);
        this.setSelectedRows([]);

        var msg = await this.translateService.get("MergeKey.Info.ChangeMixFacilitySuccess").toPromise();
        this.toastService.success(msg);
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.loader.hide();
      },
      complete: () => {
        this.loader.hide();
      }
    });
  }

  async updateMixFacilityByAdminBtn(event: Event) {
    const mergeKeys = this.selectedRows.filter((x: MergeKeySearechResult) => {
      return !isNullOrEmpty(x.mergeKey);
    }).map(x => x.mergeKey as string);

    if (mergeKeys.length === 0) {
      const msg = await this.translateService.get("MergeKey.Info.SelectMergeKeyWarning").toPromise();
      this.toastService.warn(msg, true);
      return;
    }

    const targetMixFacility = !(this.selectedRows[0]?.isMixFacility === 'Y');

    let req: ChangeMergeKeyMixFacilityRequest = {
      mergeKeys: mergeKeys,
      userId: this.userProfile.loginAccount,
      mixFacility: targetMixFacility
    };
    this.mergeKeyService.updateMixFacilityByAdmin(req).subscribe({
      next: async (result) => {
        this.searchClickBtn(event);
        this.setSelectedRows([]);

        var msg = await this.translateService.get("MergeKey.Info.UpdateMixFacilityByAdminSuccess").toPromise();
        this.toastService.success(msg);
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.loader.hide();
      },
      complete: () => {
        this.loader.hide();
      }
    });
  }

  buildMoreActionsMenu() {
    const isSuperAdmin = this.userProfile?.userType === UserType.SuperAdmin.toString();
    const has = (code: string) => isSuperAdmin || this.permissionCodes.includes(code);

    const items: MenuItem[] = [];

    if (has(PermissionConstants.BtnMergeKeyUpdateMixFacilityByAdmin)) {
      items.push({
        label: this.translateService.instant('MergeKey.Button.UpdateMixFacilityByAdmin'),
        styleClass: 'more-actions-item',
        command: (e) => this.updateMixFacilityByAdminBtn(e.originalEvent!),
      });
    }
    if (has(PermissionConstants.BtnMergeKeyCancelMergeKey)) {
      items.push({
        label: this.translateService.instant('MergeKey.Button.CancelMergeKey'),
        styleClass: 'more-actions-item',
        command: (e) => this.cancelMergeKeyBtn(e.originalEvent!),
      });
    }
    if (has(PermissionConstants.BtnMergeKeyCancelDeliveryOrderMerge)) {
      items.push({
        label: this.translateService.instant('MergeKey.Button.CancelDeliveryOrderMerge'),
        styleClass: 'more-actions-item',
        command: (e) => this.cancelDeliveryOrderMergeBtn(e.originalEvent!),
      });
    }
    this.moreActionsMenuItems = [{
      label: this.translateService.instant('MergeKey.Button.MoreActions'),
      items,
    }];
  }

  async cancelMergeKeyBtn(event: Event): Promise<void> {
    const mergeKeys = this.selectedRows.filter((x: MergeKeySearechResult) => {
      return !isNullOrEmpty(x.mergeKey);
    }).map(x => x.mergeKey as string);

    if (mergeKeys.length === 0 || this.hasSelectedCancelledMergeKey) {
      return;
    }

    var confirmMessage = await this.translateService.get('MergeKey.Confirm.CancelMergeKeyConfirmMessage').toPromise();

    this.confirmationService.confirm({
      message: confirmMessage,
      rejectVisible: true,
      accept: () => {
        this.loader.show();

        var req: CancelMergeKeyRequest = {
          mergeKeys,
          userId: this.userProfile.loginAccount
        };

        this.mergeKeyService.cancelMergeKey(req).subscribe({
          next: async () => {
            this.confirmationService.close();
            this.searchClickBtn(event);
            var msg = await this.translateService.get("MergeKey.Info.CancelMergeKeySuccess").toPromise();
            this.toastService.success(msg);
          },
          error: err => {
            this.toastErrorMessage(err.error);
            this.loader.hide();
          },
          complete: () => {
            this.loader.hide();
          }
        });
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }

  async cancelDeliveryOrderMergeBtn(event: Event): Promise<void> {
    if (this.selectedDoTaskRows.length === 0) {
      const msg = await this.translateService.get("MergeKey.Info.SelectMergeDetailWarning").toPromise();
      this.toastService.warn(msg, true);
      return;
    }

    var confirmMessage = await this.translateService.get('MergeKey.Confirm.CancelDeliveryOrderMergeConfirmMessage').toPromise();

    this.confirmationService.confirm({
      message: confirmMessage,
      rejectVisible: true,
      accept: () => {
        this.loader.show();

        var req: CancelDeliveryOrderMergeRequest = {
          mergeKey: this.selectedDoTaskRows[0]?.mergeKey as string,
          doNos: this.selectedDoTaskRows.filter((x: MergeKeyDetailResult) => {
            return !isNullOrEmpty(x.doNo);
          }).map(x => x.doNo as string),
          userId: this.userProfile.loginAccount
        };

        this.mergeKeyService.cancelDeliveryOrderMerge(req).subscribe({
          next: async () => {
            this.confirmationService.close();

            var currentMother = this.results.filter((x: MergeKeySearechResult) => {
              return x.mergeKey === req.mergeKey;
            });
            if (currentMother.length > 0) {
              this.searchDetailClick({
                originEvent: event,
                rowData: currentMother[0],
                expanded: false
              } as RowExpandedEvent<MergeKeySearechResult>);
            }

            var msg = await this.translateService.get("MergeKey.Info.CancelDeliveryOrderMergeSuccess").toPromise();
            this.toastService.success(msg);
          },
          error: err => {
            this.toastErrorMessage(err.error);
            this.loader.hide();
          },
          complete: () => {
            this.loader.hide();
          }
        });
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }

  onResize(event: Event) {
    if (window.innerWidth <= this.SMALL_SCREEN) {
      this.isSmallScreen = true;
    } else {
      this.isSmallScreen = false;
    }
  }

  checkMixFacilityDialogConfirmBtnClick(event: any) {
    this.checkMixFacilityDialog = false;
  }

  checkMixFacilityDialogCancelBtnClick(event: any) {
    this.loader.show();
    let req: ChangeMergeKeyMixFacilityRequest = {
      mergeKeys: [this.checkMixFacilityDialogKey],
      userId: this.userProfile.loginAccount,
      mixFacility: false
    };
    this.mergeKeyService.changeMixFaility(req).subscribe({
      next: async (result) => {
        var msg = await this.translateService.get("MergeKey.Info.ChangeMixFacilitySuccess").toPromise();
        this.toastService.success(msg);
        this.searchClickBtn(event);
        this.setSelectedRows([]);
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.loader.hide();
      }
    });
    this.loader.hide();
    this.checkMixFacilityDialog = false;
    this.checkMixFacilityDialogKey = null;
  }

  dateOnChange(date: any) {
    this.searchForm.controls.createDtStart.setValue(date.startDate);
    this.searchForm.controls.createDtEnd.setValue(date.endDate);
  }
}

